// frontend/src/api/apiFunction/modelServices.js
import { httpGet, httpPost, httpPut, httpDelete } from "../../utils/httpMethods";
import axios from "axios";
import { MODEL_URL, MODEL_TYPES_URL, SOURCES_URL } from "../restEndpoint";

// Get all models with pagination and search
export const getAllModels = async (params = {}) => {
    const queryParams = new URLSearchParams();
    
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.search) queryParams.append('search', params.search);
    
    const queryString = queryParams.toString();
    const url = queryString ? `${MODEL_URL}?${queryString}` : MODEL_URL;
    
    return await httpGet({ url });
};

// Get a model by ID
export const getModelById = async (id) => {
    return await httpGet({ url: `${MODEL_URL}/${id}` });
};

// Create a new model
export const createModel = async (payload) => {
    return await httpPost({ url: `${MODEL_URL}`, payload });
};

// Update a model by ID
export const updateModel = async (id, payload) => {
    return await httpPut({ url: `${MODEL_URL}/${id}`, payload });
};

// Delete a model by ID
export const deleteModel = async (id) => {
    // Use direct axios.delete without a request body to avoid servers that error on DELETE bodies
    const authUser = JSON.parse(localStorage.getItem("user"));
    const headers = authUser?.token ? { Authorization: `Bearer ${authUser.token}` } : {};
    return await axios.delete(`${MODEL_URL}/${id}`, { headers });
}; 

// Get all model types
export const getAllModelTypes = async () => {
    return await httpGet({ url: `${MODEL_TYPES_URL}` });
};

// Get all sources
export const getAllSources = async () => {
    return await httpGet({ url: `${SOURCES_URL}` });
};

// Get OpenRouter providers and models
export const getOpenRouterData = async () => {
    return await httpGet({ url: `${MODEL_URL}/openrouter/data` });
}; 